//@ts-check
import Axios from 'axios';
import { API_BASE, STATUS_FAILURE_ILLEGAL_REQUEST, STATUS_FAILURE_NOT_AUTHORIZED_DEMO, STATUS_ERROR_INTERNAL, STATUS_SUCCESS } from '@/common/constants';
import { openFailedDialog } from '@/common/components/kf-dialog';

const formatBody = (data) => {
  if (!data) {
    return data;
  }

  if (data instanceof FormData || data instanceof URLSearchParams) {
    return data;
  }

  if (typeof data === 'string') {
    return data;
  }

  const params = new URLSearchParams();
  Object.keys(data).forEach(key => params.append(key, data[key]));
  return params.toString();
};

export const errorHandler = (e) => {
  switch (e.status) {
    case STATUS_FAILURE_ILLEGAL_REQUEST:
      return openFailedDialog('不正なリクエストです。');

    case STATUS_FAILURE_NOT_AUTHORIZED_DEMO:
      return openFailedDialog('デモ版では更新を伴う操作はできません。');

    case STATUS_ERROR_INTERNAL:
      return openFailedDialog('サーバエラーです。');

    default:
      console.error(e);
      if (e.status != null) {
        return openFailedDialog(`エラーが発生しました。エラーコード：${e.status}`);
      } else if (e.response) {
        return openFailedDialog(`エラーが発生しました。エラーコード：${e.response.status}`);
      } else if (e.message === 'Network Error') {
        return openFailedDialog('ネットワークエラーが発生しました。ページを再度読み込んでください。');
      } else {
        return openFailedDialog(`エラーが発生しました。\n ${e.message || ''}`);
      }
  }
};

/**
 * @param {string} path 
 * @param {Record<string, any>} body 
 * @param {string} [apiBase] 
 * @returns
 */
export const ajaxPost = (path, body, apiBase) => {
  return new Promise((resolve, reject) => {
    Axios.post(path, formatBody(body), {
      withCredentials: true,
      baseURL: `${apiBase || API_BASE}/top`,
      timeout: 60 * 1000 * 10,
      headers: {
        'Content-type': 'application/x-www-form-urlencoded'
      }
    })
      .then(({ data }) => {
        if (data.status == STATUS_SUCCESS) {
          resolve(data);
        } else {
          reject(data);
        }
      })
      .catch(err => {
        reject(err);
      });
  });
};